import { type LicenseStatus } from "@clipboard-health/contract-worker-app-bff";

export const ROLES_PAGE_SCROLL_POSITION_KEY = "roles-page-scroll-position";

export const LICENSE_SORT_ORDER: Record<LicenseStatus, number> = {
  ACTIVE: 0,
  PENDING: 1,
  REJECTED: 2,
  EXPIRING: 3,
  EXPIRED: 4,
  ARCHIVED: 5,
};
